import * as React from "react"
import { Button, type buttonVariants } from "@/components/ui/button"
import type { VariantProps } from "class-variance-authority"

type IconButtonProps = Omit<
  React.ComponentProps<"button">,
  "children" | "aria-label"
> &
  VariantProps<typeof buttonVariants> & {
    "aria-label": string
    children: React.ReactNode
  }

/**
 * Icon-only button. `aria-label` is required in the type system —
 * an unlabeled icon button must not compile.
 */
function IconButton({
  variant = "ghost",
  size = "icon",
  className,
  ...props
}: IconButtonProps) {
  return (
    <Button variant={variant} size={size} className={className} {...props} />
  )
}

export { IconButton }
